import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserTypeHistoryReadPage = lazy(() => import('../views/read/UserTypeHistoryReadPage'));

export function UserTypeHistoryReadPageLazy() {
	return (
		<PageSuspense>
			<UserTypeHistoryReadPage />
		</PageSuspense>
	);
}
